// web_components/wcLinksPanel/wcLinksPanel_Renderer.ts

/**
 * Generates the HTML for the wc-links-panel component.
 * Handles CSS, variables, etc.
 *
 * @param {object} dataAttributes - Data attributes for styling and contextual information.
 * @param {string} instanceId - A unique instance ID for generating unique element IDs.
 * @returns {string} - The HTML string for the content component.
 */
export function renderProductHTML(dataAttributes: any, instanceId: string): string {
	// Initialize styleTag to an empty string
	let styleTag = '';

	// Check if 'css' exists in dataAttributes and is an object
	if (dataAttributes.css && typeof dataAttributes.css === 'object') {
		styleTag = `<style>`;
		for (const [selector, styles] of Object.entries(dataAttributes.css)) {
			styleTag += `${selector} { ${styles} }`;
		}
		styleTag += `</style>`;
	}

	// Access variables and assign to 'variables', defaulting to an empty object if undefined
	const variables = dataAttributes.variables || {};

	return `
        ${styleTag}
        <section id="${instanceId}" class="wc-links-panel">
        	<div class="wc-links-panel__container">
				<div>
					<h3 ${window.serverData?.storeName == 'Warehouse Wines' ? 'class="wc-links-panel__font-medium"' : ''}>
    					${variables.linksPanelHeading}
					</h3>
				</div>
				<div>
					<a href="${variables.linksPanelCTAUrl1}" class="wc-links-panel__cta-link">
						${variables.linksPanelCTAText1}
					</a>
					<a href="${variables.linksPanelCTAUrl2}" class="wc-links-panel__cta-link">
						${variables.linksPanelCTAText2}
					</a>
					<a href="${variables.linksPanelCTAUrl3}" class="wc-links-panel__cta-link">
						${variables.linksPanelCTAText3}
					</a>				
				</div>
			</div>
        </section>
    `;
}
